import { action, observable, makeObservable } from 'mobx';
import { menuProvider } from 'core/providers';
import _ from 'lodash';

class MenuStore {
	@observable menu = [];
	menuIsOpen = {};
	isMenuInitialSet = false;

	constructor(rootStore) {
		makeObservable(this);
		this.rootStore = rootStore;
	}

	// Open/close toggle for submenus
	@action.bound toggleMenu = menuKey => {
		this.menuIsOpen[menuKey] = !this.menuIsOpen[menuKey];
		this.isMenuInitialSet = true;
		menuProvider.refresh();
	};

	@action.bound setMenu = menu => (this.menu = menu);

	// Make sure that submenu is open if selected
	@action.bound syncOpenSubmenu = menuKey => {
		_.each(this.menu, item => {
			if (item.children) {
				_.each(item.children, itemChild => {
					if (itemChild.route == menuKey && this.isMenuInitialSet == false) {
						this.menuIsOpen[item.route] = true;
						this.isMenuInitialSet = true;
					}
					if (itemChild.subroutes) {
						_.each(itemChild.subroutes, subroute => {
							if (subroute == menuKey && this.isMenuInitialSet == false) {
								this.menuIsOpen[item.route] = true;
								this.isMenuInitialSet = true;
							}
						});
					}
				});
			}
		});
	};
}

export default MenuStore;
